var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
import { __decorate, __metadata } from "tslib";
import contService from "@/core/services/contService";
import JwtService from "@/core/services/JwtService";
import { Mutations } from "@/store/enums/StoreEnums";
import { Plano_ContasActions } from "@/store/enums/ContEnums";
import { Module, Action, VuexModule } from "vuex-module-decorators";
let Plano_ContasModule = class Plano_ContasModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.errors = {};
        this.isAuthenticated = !!JwtService.getToken();
    }
    [_a = Plano_ContasActions.POST_PLANO_CONTAS](data) {
        return new Promise(resolve => {
            contService.post("Plano_Contas/Post", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_b = Plano_ContasActions.MOVE_PLANO_CONTAS](data) {
        return new Promise(resolve => {
            contService.post("Plano_Contas/MovePlanoContas", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_c = Plano_ContasActions.PUT_PLANO_CONTAS](data) {
        return new Promise(resolve => {
            contService.put("Plano_Contas/Put", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_d = Plano_ContasActions.DELETE_PLANO_CONTAS](data) {
        return new Promise(resolve => {
            contService.delete("Plano_Contas/Delete", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_e = Plano_ContasActions.DELETE_RANGE_PLANO_CONTAS](data) {
        return new Promise(resolve => {
            contService.delete("Plano_Contas/DeleteRange", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_f = Plano_ContasActions.FILTER_PLANO_CONTAS](data) {
        return new Promise(resolve => {
            contService.post("Plano_Contas/Filter", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_g = Plano_ContasActions.GET_PLANO_CONTAS]() {
        return new Promise(resolve => {
            contService.get("Plano_Contas/Get")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_h = Plano_ContasActions.GETWITHDISABLED_PLANO_CONTAS]() {
        return new Promise(resolve => {
            contService.get("Plano_Contas/GetWithDisabled")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_j = Plano_ContasActions.GET_BY_ID_PLANO_CONTAS](data) {
        return new Promise(resolve => {
            contService.get("Plano_Contas/GetById", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_k = Plano_ContasActions.GET_FROM_CONTA_PLANO_CONTAS](data) {
        return new Promise(resolve => {
            contService.post("Plano_Contas/GetFromConta", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
};
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Plano_ContasModule.prototype, _a, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Plano_ContasModule.prototype, _b, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Plano_ContasModule.prototype, _c, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Plano_ContasModule.prototype, _d, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Plano_ContasModule.prototype, _e, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Plano_ContasModule.prototype, _f, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Plano_ContasModule.prototype, _g, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Plano_ContasModule.prototype, _h, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Plano_ContasModule.prototype, _j, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Plano_ContasModule.prototype, _k, null);
Plano_ContasModule = __decorate([
    Module
], Plano_ContasModule);
export default Plano_ContasModule;
//# sourceMappingURL=Plano_ContasModule.js.map